import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeComponent from "../components/home/HomeComponent";
import ContactPage from "../components/contactus/ContactUsComponent";
import AboutUsPage from "../components/aboutus/AboutUsComponent";
import GalleryPage from "../components/gallery/GalleryComponent";
import RegisterNow from "../components/registernow/RegisterNowComponent";
import SponsorServicePage from "../components/sponsor/SponsorServicePage";
import AttendeeDetails from "../components/attendeeDetails/AttendeeDetailsComponent";
import PaymentPage from "../components/paymentpage/PaymentPageComponent";
import TestimonialsPage from "../components/testimonials/TestimonialsComponent";
import PlatformPage from "../components/platform/PlatformComponent";
import PlatformComponent from "../components/platformComponent/Platform";
import TermsComponent from "../components/terms/TermsComponent";
import PrivacyAndPolicyComponent from "../components/privacyPolicy/PrivacyAndPolicyComponent";
import ShippingPolicyComponent from "../components/shippingPolicy/ShippingPolicyComponent";
import RefundPolicyComponent from "../components/cancellation&Refund/RefundPolicyComponent";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/aboutus" element={<AboutUsPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/register-now" element={<RegisterNow />} />
      <Route path="/sponsor-registration" element={<SponsorServicePage />} />
      <Route path="/attendee-details" element={<AttendeeDetails />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/testimonials" element={<TestimonialsPage />} />
      <Route path="/platforms" element={<PlatformPage />} />
      <Route path="/platform-page" element={<PlatformComponent />} />
      <Route path="/terms-of-use" element={<TermsComponent />} />
      <Route path="/privacy-policy" element={<PrivacyAndPolicyComponent />} />
      <Route path="/shipping-policy" element={<ShippingPolicyComponent />} />
      <Route path="/refund-policy" element={<RefundPolicyComponent />} />
    </Routes>
  );
};

export default AppRoutes;
